import React from 'react';

import isEmpty from 'lodash/isEmpty';

import {
  DescriptionList,
  DescriptionItem,
  Link,
  Stack,
  Typography,
} from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import { StatusIndicator } from 'scenes/Campaigns/components/shared';
import { ColorLabelTextListItem } from 'scenes/Campaigns/components/shared';
import { campaignDetailsLink } from 'scenes/Campaigns/GGCampaigns/navigation';

import { OwnerListItem } from './components';

const General = ({
  data = {},
  onOpenAffiliate,
  onOpenPromoCodeDetails,
  onCopyLink,
  onOpenCampaign,
  onOpenParentCampaignDetails,
}) => {
  const isOriginalCampaign = data?.linkedCampaignInfo?.linkedCampaignType === 1;

  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem
        label={isOriginalCampaign ? 'New campaign' : 'Original campaign'}
        field={'linkedCampaignInfo'}
        type={({ value: { campaignName, campaignId: id } }) => {
          return (
            <ScreenLink
              link={campaignDetailsLink}
              pathParams={{
                id,
              }}
            >
              <Typography> {campaignName}</Typography>
            </ScreenLink>
          );
        }}
        onValueClick={onOpenCampaign}
      />
      <DescriptionItem
        field={'linkedCampaignInfo.date'}
        label={`Stats collection ${isOriginalCampaign ? 'end' : 'start'} date`}
        type={'date'}
        template={'LL'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Campaign type'}
        field={'targetingActivityType'}
      />
      <DescriptionItem
        label={'Labels'}
        field={'labels'}
        type={'typographyList'}
        unitsLabel={'Labels'}
        limit={5}
        item={ColorLabelTextListItem}
      />
      <DescriptionItem label={'Application'} field={'application.name'} />
      <DescriptionItem label={'Network'} field={'network.name'} />
      <DescriptionItem
        label={'Affiliate'}
        field={'affiliate'}
        linkLabelField={'name'}
        type={'link'}
        onValueClick={onOpenAffiliate}
      />
      <DescriptionItem label={'Platform'} field={'platform.name'} />
      <DescriptionItem label={'Country'} field={'country.name'} />
      <DescriptionItem
        label={'Previous owners'}
        field={'owners'}
        type={'typographyList'}
        unitsLabel={'Labels'}
        limit={5}
        item={OwnerListItem}
      />
      <DescriptionItem label={'Locale'} field={'locale'} />
      <DescriptionItem label={'Track RE'} field={'activityType'} />
      <DescriptionItem
        label={'Alternative campaign name'}
        field={'alternativeId'}
      />
      <DescriptionItem
        label={'Conversion page flows'}
        field={'conversionPageFlow.name'}
      />
      <DescriptionItem
        label={'Conversion pages'}
        field={'conversionPages'}
        type={'typographyList'}
        unitsLabel={'Conversion pages'}
        limit={5}
        listType={'link'}
        mt={-1.25}
        mb={-1.25}
        item={({ link, conversionPageName }) => (
          <Stack direction={'row'} alignItems={'center'}>
            <Link
              href={link}
              target={'_blank'}
              clipboardCopy={true}
              onCopy={onCopyLink}
              width={'100%'}
            >
              <Typography>{conversionPageName}</Typography>
            </Link>
          </Stack>
        )}
      />
      <DescriptionItem label={'Link format'} field={'linkFormat.name'} />
      <DescriptionItem
        label={'Promo code'}
        field={'promoCode'}
        type={({ value: { status, id, name, period } }) => {
          return (
            <Stack direction={'row'} alignItems={'center'}>
              {status?.name ? <StatusIndicator status={status?.name} /> : null}
              <Link onClick={() => onOpenPromoCodeDetails(id)}>
                <Typography noWrap={true}>{name}</Typography>
              </Link>
              {!isEmpty(period) ? (
                <Typography>
                  &nbsp; (
                  <DateRangeFormatter value={period} template={'LL'} />)
                </Typography>
              ) : null}
            </Stack>
          );
        }}
      />
      <DescriptionItem
        label={'Parent campaign'}
        field={'parentCampaign'}
        linkLabelField={'name'}
        type={'link'}
        onValueClick={onOpenParentCampaignDetails}
      />
    </DescriptionList>
  );
};

export default General;
